export default "__VITE_ASSET__R3P8T9Z3tXuGMzK1tl7rzA__"